import React from "react";
import { Modal, Button } from "react-bootstrap";

const SignatureRequiredModal = ({ show, onClose }) => (
  <Modal
    show={show}
    onHide={onClose}
    centered
    dialogClassName="contract-modal-dialog contract-create-dialog"
  >
    <Modal.Header closeButton>
      <Modal.Title>Add Client Signature</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="mb-2">
        This contract needs the <strong>Client Signature</strong> field so your
        client can sign.
      </p>
      <p className="mb-0">
        Use <strong>+ Insert Variable → Signature</strong> to add it to your
        contract body.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={onClose}>
        Back to Editor
      </Button>
    </Modal.Footer>
  </Modal>
);

export default SignatureRequiredModal;
